// Copyright (c) 2025 Deere & Company

import rgaBoReport from './rga-bo-reports';

/* eslint-disable sorting/sort-object-props */

export default {
    childRoutes: [
        rgaBoReport
    ]
};

/* eslint-enable sorting/sort-object-props */



// WEBPACK FOOTER //
// ./src/routes/rga/reports/index.js